import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush
    .call(this, location)
    .catch((err) => console.log(err, "err"));
};

const routes = [
  {
    path: "/",
    redirect: "/home"
  },
  {
    // 首页
    path: "/home",
    name: "Home",
    component: () => import("@/views/home/index")
  },
  {
    // 首页详情
    path: "/homeDetails",
    name: "HomeDetails",
    component: () => import("@/views/home/homeDetails/index")
  },
  {
    // 课程详情
    path: "/courseDetails",
    name: "CourseDetails",
    component: () => import("@/views/home/courseDetails/index")
  },
  {
    // 查看PPT
    path: "/lookPPT",
    name: "LookPPT",
    component: () => import("@/views/home/courseDetails/lookPPT")
  },
  {
    // APP查看PPT
    path: "/appLookPPT",
    name: "AppLookPPT",
    component: () => import("@/views/test/appLookPPT")
  },
  {
    // 登录页
    path: "/login",
    name: "Login",
    component: () => import("@/views/login/index")
  },
  {
    // 我的
    path: "/my",
    name: "My",
    component: () => import("@/views/my/index")
  },
  {
    // 搜索
    path: "/search",
    name: "Search",
    component: () => import("@/views/search/index")
  },
  {
    // 测试
    path: "/test",
    name: "Test",
    component: () => import("@/views/test/index")
  }
];

const router = new VueRouter({
  routes
});

export default router;
